(function () {
  'use strict';

  function onReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  }

  onReady(function () {
    initMobileMenu();
    initFilterToggle();
    initBrandCarousel();
    initConsultationModal();
    initProductVariants();
    initProductFinder();
    initQuantityButtons();
  });

  function initMobileMenu() {
    var menu = document.querySelector('[data-mobile-menu]');
    var toggles = document.querySelectorAll('[data-mobile-toggle]');

    if (!menu || !toggles.length) return;

    function setOpen(open) {
      if (open) {
        menu.removeAttribute('hidden');
      } else {
        menu.setAttribute('hidden', '');
      }

      toggles.forEach(function (toggle) {
        toggle.setAttribute('aria-expanded', String(open));
      });
    }

    setOpen(false);

    toggles.forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var isHidden = menu.hasAttribute('hidden');
        setOpen(isHidden);
      });
    });

    menu.addEventListener('click', function (event) {
      var target = event.target;
      if (!(target instanceof Element)) return;

      if (target.closest('a')) {
        setOpen(false);
      }
    });
  }

  function initFilterToggle() {
    var toggles = document.querySelectorAll('[data-filter-toggle]');

    if (!toggles.length) return;

    toggles.forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var targetSelector = toggle.getAttribute('data-filter-toggle');
        if (!targetSelector) return;

        var target = document.querySelector(targetSelector);
        if (!target) return;

        var isHidden = target.hasAttribute('hidden');

        if (isHidden) {
          target.removeAttribute('hidden');
        } else {
          target.setAttribute('hidden', '');
        }

        toggle.setAttribute('aria-expanded', String(isHidden));
      });
    });
  }

  function initBrandCarousel() {
    var carousels = document.querySelectorAll('[data-brand-carousel]');
    if (!carousels.length) return;

    carousels.forEach(function (carousel) {
      var slides = carousel.querySelectorAll('[data-brand-slide]');
      var dots = carousel.querySelectorAll('[data-brand-dot]');
      var prev = carousel.querySelector('[data-brand-prev]');
      var next = carousel.querySelector('[data-brand-next]');

      if (!slides.length) return;

      if (slides.length <= 1) {
        if (prev) prev.setAttribute('hidden', '');
        if (next) next.setAttribute('hidden', '');
      }

      var index = 0;
      var timer = null;
      var autoplayEnabled = carousel.getAttribute('data-autoplay') === 'true';
      var autoplaySpeed = parseInt(carousel.getAttribute('data-autoplay-speed') || '5', 10) * 1000;

      function update(newIndex) {
        index = (newIndex + slides.length) % slides.length;

        slides.forEach(function (slide, idx) {
          slide.classList.toggle('is-active', idx === index);
        });

        dots.forEach(function (dot, idx) {
          dot.classList.toggle('is-active', idx === index);
        });
      }

      function startAuto() {
        if (!autoplayEnabled || slides.length <= 1) return;

        stopAuto();

        timer = window.setInterval(function () {
          update(index + 1);
        }, autoplaySpeed > 0 ? autoplaySpeed : 5000);
      }

      function stopAuto() {
        if (timer) {
          window.clearInterval(timer);
          timer = null;
        }
      }

      if (prev) {
        prev.addEventListener('click', function () {
          update(index - 1);
        });
      }

      if (next) {
        next.addEventListener('click', function () {
          update(index + 1);
        });
      }

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var raw = dot.getAttribute('data-brand-dot');
          var selected = raw ? parseInt(raw, 10) : 0;
          update(selected);
        });
      });

      carousel.addEventListener('mouseenter', stopAuto);
      carousel.addEventListener('mouseleave', startAuto);

      update(0);
      startAuto();
    });
  }

  function initConsultationModal() {
    var modal = document.querySelector('[data-consult-modal]');
    var openers = document.querySelectorAll('[data-consult-open]');

    if (!modal || !openers.length) return;

    var closers = modal.querySelectorAll('[data-consult-close]');

    function setOpen(open) {
      if (open) {
        modal.removeAttribute('hidden');
        document.body.style.overflow = 'hidden';
      } else {
        modal.setAttribute('hidden', '');
        document.body.style.overflow = '';
      }
    }

    openers.forEach(function (opener) {
      opener.addEventListener('click', function (e) {
        e.preventDefault();
        setOpen(true);
      });
    });

    closers.forEach(function (closer) {
      closer.addEventListener('click', function (e) {
        e.preventDefault();
        setOpen(false);
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !modal.hasAttribute('hidden')) {
        setOpen(false);
      }
    });
  }

  function initProductVariants() {
    var wrappers = document.querySelectorAll('[data-product-form-wrapper]');
    if (!wrappers.length) return;

    wrappers.forEach(function (wrapper) {
      var section = wrapper.closest('section');
      if (!section) return;

      var script = section.querySelector('[data-product-variants]');
      var idInput = wrapper.querySelector('[data-variant-id]');
      var priceNode = wrapper.querySelector('[data-product-price]');
      var compareNode = wrapper.querySelector('[data-product-compare-price]');
      var saleBadge = wrapper.querySelector('[data-product-sale-badge]');
      var addButton = wrapper.querySelector('[data-add-to-cart]');
      var selectors = wrapper.querySelectorAll('[data-option-position]');

      if (!script || !idInput || !selectors.length) return;

      var variants;
      try {
        variants = JSON.parse(script.textContent || '[]');
      } catch (error) {
        variants = [];
      }

      if (!Array.isArray(variants) || !variants.length) return;

      function money(cents) {
        return new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: document.documentElement.getAttribute('data-currency') || 'USD'
        }).format((cents || 0) / 100);
      }

      function selectedOptions() {
        return Array.prototype.map.call(selectors, function (select) {
          return select.value;
        });
      }

      function findVariant() {
        var selected = selectedOptions();

        return variants.find(function (variant) {
          if (!variant || !variant.options) return false;

          return variant.options.every(function (value, idx) {
            return value === selected[idx];
          });
        });
      }

      function applyVariant(variant) {
        if (!variant) {
          if (addButton) {
            addButton.disabled = true;
            addButton.textContent = 'Unavailable';
          }
          return;
        }

        idInput.value = variant.id;

        if (priceNode && typeof variant.price === 'number') {
          priceNode.textContent = money(variant.price);
        }

        if (compareNode) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            compareNode.textContent = money(variant.compare_at_price);
            compareNode.hidden = false;
          } else {
            compareNode.hidden = true;
          }
        }

        if (saleBadge) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            var discount = Math.round(
              ((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100
            );
            saleBadge.textContent = '-' + discount + '%';
            saleBadge.hidden = false;
          } else {
            saleBadge.hidden = true;
          }
        }

        if (addButton) {
          addButton.disabled = !variant.available;
          addButton.textContent = variant.available ? 'Add to cart' : 'Sold out';
        }
      }

      selectors.forEach(function (selector) {
        selector.addEventListener('change', function () {
          applyVariant(findVariant());
        });
      });

      applyVariant(findVariant() || variants[0]);
    });
  }

  function initProductFinder() {
    var root = document.querySelector('[data-product-finder]');
    if (!root) return;

    var submit = root.querySelector('[data-finder-submit]');
    var reset = root.querySelector('[data-finder-reset]');
    var result = root.querySelector('[data-finder-result]');
    var title = root.querySelector('[data-finder-title]');
    var copy = root.querySelector('[data-finder-copy]');
    var link = root.querySelector('[data-finder-link]');
    var script = root.querySelector('[data-finder-map]');

    if (!submit || !result || !title || !copy || !link || !script) return;

    var map;
    try {
      map = JSON.parse(script.textContent || '{}');
    } catch (error) {
      map = {};
    }

    function value(name) {
      var input = root.querySelector('[data-finder-input="' + name + '"]');
      return input ? input.value : '';
    }

    function recommend() {
      var setting = value('setting');
      var priority = value('priority');
      var budget = value('budget') || 'mid';
      var key = budget;

      if (setting === 'rehab' || priority === 'durability') {
        key = 'high';
      } else if (priority === 'space' && budget !== 'high') {
        key = 'mid';
      }

      return map[key] || map.mid || map.low;
    }

    submit.addEventListener('click', function () {
      var rec = recommend();
      if (!rec) return;

      title.textContent = rec.title || 'Recommended collection';
      copy.textContent = rec.copy || '';
      link.setAttribute('href', rec.url || '/collections/all');
      result.removeAttribute('hidden');

      result.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    });

    if (reset) {
      reset.addEventListener('click', function () {
        result.setAttribute('hidden', '');
      });
    }
  }

  function initQuantityButtons() {
    document.addEventListener('click', function (e) {
      var plusBtn = e.target.closest('.qty-plus');
      var minusBtn = e.target.closest('.qty-minus');

      if (plusBtn) {
        var plusWrapper = plusBtn.closest('.quantity-selector');
        if (!plusWrapper) return;

        var plusInput = plusWrapper.querySelector('input');
        if (!plusInput) return;

        plusInput.value = parseInt(plusInput.value || 1, 10) + 1;
        plusInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      if (minusBtn) {
        var minusWrapper = minusBtn.closest('.quantity-selector');
        if (!minusWrapper) return;

        var minusInput = minusWrapper.querySelector('input');
        if (!minusInput) return;

        var current = parseInt(minusInput.value || 1, 10);
        if (current > 1) {
          minusInput.value = current - 1;
          minusInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });
  }
})();


// ASK EXPERT BUTTON HIDE IN MOBILE
document.addEventListener("DOMContentLoaded", function () {

  const button = document.querySelector(".mobile-expert-btn");
  const footer = document.querySelector("footer");

  if (!button || !footer) return;

  window.addEventListener("scroll", function () {

    const footerTop = footer.getBoundingClientRect().top;
    const windowHeight = window.innerHeight;

    if (footerTop < windowHeight) {
      button.style.opacity = "0";
      button.style.pointerEvents = "none";
      button.style.transform = "translateY(20px)";
    } else {
      button.style.opacity = "1";
      button.style.pointerEvents = "auto";
      button.style.transform = "translateY(0)";
    }

  });

});